import { useEffect } from 'react';
import { useFormState } from 'shared';

export function useReaderRequestForm(readerRequest, onChangeInput) {
  const [readerRequestInputs, setReaderInputs] = useFormState(readerRequest, onChangeInput);

  useEffect(() => {
    setReaderInputs({ ...readerRequest }, false);
  }, [readerRequest]);

  return {
    readerInputs: readerRequestInputs
  };
}
